import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function Input({ input, isInvalid, value, placeholder }: Props) {
  return (
    <input
      type="password"
      value={value}
      placeholder={placeholder}
      className={classNames(styles.input, {
        [styles.invalid]: isInvalid,
      })}
      onChange={({ target }) => input(target.value)}
    />
  );
}

export { Input };
